import { produce, current } from "immer";

import { checkHasMultiFloorOccupiedBus } from "@modules/Tickets/SeatDetails/heplers";

import {
  updateTickets,
  resetTickets,
  changeSeatNumber,
  updateSeatPlan,
  updateBicycles,
  updateTransfers,
  updateIsCampaign,
  setSeatShiftNotified,
  setMultiFloorOccupiedBusNotified,
  updateLegsViewed,
  updateFareClasses,
  setNewFareClasses,
  setBusFloor,
  initUpdateFareClasses,
} from "./actions";

const initialTicketsState = {
  isConfirmLeaveFromTicketFlow: false,
  bus: [],

  // modals
  isBasketExrpired: false,
  isSomethingWrong: false,
  isSomethingWrongMessage: "",
  isSomethingWrongTitle: "",

  // tickets search
  lastSearch: "",
  isOpenBlind: false,
  isOutboundSelected: false, // new
  isInboundSelected: false, // new

  // seat details
  isOutbound: true,
  activeBus: 1,
  activePassenger: 1,
  passengersCount: 1, // need remove
  activeBusFloor: null,

  passengerDetailsStepDisabled: true,
  seatDetailsStepDisabled: true,
  // isBasketTimeOut: false,

  // vouchers
  vouchers: {
    fullyCoversCost: false,
    totalVouchersValue: 0,
    showVoucherInput: false,
    approved: [],
    newVoucher: "",
    newVoucherValue: 0,
    statusVaucher: "",
  },

  productsIds: [],
  extraSeatsIds: [],
  extraSeatsCount: 0,
  extraSeatLoading: false,

  totalPrice: null,
  prices: {},
  inbound: {
    selected: false,
  },
  outbound: {
    selected: false,
  },
  isPassengersInfoConfirmed: false,
  step: 2,

  passsengersInfo: {},
  passsengersInfoDone: false,
  // isCorporate: false,

  // currency: "CURRENCY.EUR",
  // currencyName: "EUR",
  // symbol: "€",
  showCurrencies: true,
  inboundJourneyPriceClass: "Regular",
  outboundJourneyPriceClass: "Regular",
  passengerPrices: {},
  passengersFee: 0,
  paymentSuccessful: false,
  basketTransfers: [],
  basketTransfersPrice: 0,
  hasTransfers: false,
  hasOutboundBicycles: false,
  hasInboundBicycles: false,
  forAnalitics: {},
  allJourneysLegs: [],
  GTM: {
    selectSeatsStep: false,
    passengerInfoStep: false,
    paymentStep: false,
    thanksStep: false,
  },
  affiliateId: "",
  transfers: {
    called: false,
    isOutbound: false,
    isInbound: false,
    inboundInformation: {},
    outboundInformation: {},
    InboundJourneys: [],
    OutboundJourneys: [],
    isOutboundOther: false,
    isInboundOther: false,
    outboundTransfer: {
      TransferId: "",
      PassengerName: "",
      PassengerPhone: "",
      Quantity: 1,
    },
    inboundTransfer: {
      TransferId: "",
      PassengerName: "",
      PassengerPhone: "",
      Quantity: 1,
    },
  },
  bicycles: {
    info: {},
    called: false,
    isOutbound: false,
    isInbound: false,
    isWheelchairAccessible: false,
    outboundBicycle: {
      Quantity: 1,
      reserved: 0,
    },
    inboundBicycle: {
      Quantity: 1,
      reserved: 0,
    },
  },
  refund: {
    ticketNumber: "",
    modificationInfo: null,
    isPublic: true,
  },
  payment: {
    status: "",
    type: "",
    objects: [],
  },
  selectedJourneyId: "",
  confirmPartnerBusNotice: false,
  multiFloorOccupiedBusNotified: false,
  seatShiftNotified: false,
  hasSeatShift: false,
  legsViewed: {},
  hasDoubleDeck: false,
  hasMultiFloorOccupiedBus: false,
};

const initialTicketsStateV2 = {
  steps: {
    search: {
      gtm: false,
    },
    selectSeats: {
      gtm: false,
    },
    passengerInfo: {
      gtm: false,
    },
    paymentStep: {
      gtm: false,
    },
    thanksStep: {
      gtm: false,
    },
  },
  refund: {},
  transfers: {},
  bicycles: {},
  vouchers: {},
  payment: {},
};

export const ticketsSlice = (set, gets) => ({
  ...initialTicketsState,
});

export const ticketsActions = (set, get) => ({
  [resetTickets]: () => {
    set((state) => ({
      ...state,
      tickets: {
        ...initialTicketsState,
      },
    }));
  },
  [updateTickets]: (payload) => {
    set((state) => ({
      ...state,
      tickets: {
        ...state.tickets,
        ...payload,
      },
    }));
  },
  [updateIsCampaign]: (payload) => {
    set(
      produce((state) => {
        const { IsCampaign, isOutbound, orderNumber, number } = payload;
        state.tickets.products[
          isOutbound ? "OutboundJourneys" : "InboundJourneys"
        ][0].Legs[orderNumber - 1].SeatInfo[number - 1].IsCampaign =
          !IsCampaign;
      }),
    );
  },
  updateExtraSeatIsCampaign: (payload) => {
    set(
      produce((state) => {
        const { productId, IsCampaign, isOutbound, orderNumber } = payload;
        const seatInfo =
          state.tickets.products[
            isOutbound ? "OutboundJourneys" : "InboundJourneys"
          ][0].Legs[orderNumber - 1].SeatInfo;

        const extraSeatIndex = seatInfo.findIndex(
          (seat) => seat.ProductId === productId,
        );

        if (extraSeatIndex !== -1) {
          seatInfo[extraSeatIndex].IsCampaign = !IsCampaign;
        }
      }),
    );
  },
  [updateBicycles]: (payload) => {
    set((state) => ({
      ...state,
      tickets: {
        ...state.tickets,
        bicycles: {
          ...state.tickets.bicycles,
          ...payload,
        },
      },
    }));
  },
  [updateTransfers]: (payload) => {
    set((state) => ({
      ...state,
      tickets: {
        ...state.tickets,
        transfers: {
          ...state.tickets.transfers,
          ...payload,
        },
      },
    }));
  },
  [updateSeatPlan]: (payload) => {
    set(
      produce((state) => {
        const { newLegs } = payload;
        newLegs.forEach((leg) => {
          if (leg.IsOutbound) {
            state.tickets.products.OutboundJourneys[0].Legs[
              leg.OrderNumber - 1
            ].SeatPlan = leg;
          } else {
            state.tickets.products.InboundJourneys[0].Legs[
              leg.OrderNumber - 1
            ].SeatPlan = leg;
          }
        });

        try {
          const hasMultiFloorOccupiedBus = checkHasMultiFloorOccupiedBus(
            state.tickets.products,
          );

          state.tickets.hasMultiFloorOccupiedBus = hasMultiFloorOccupiedBus;
        } catch (e) {
          console.log("e", e);
        }
      }),
    );
  },
  [changeSeatNumber]: (payload) => {
    const { directions, activeBus, activePassenger, passanger } = payload;

    const prices = passanger.Prices.filter(
      (price) => passanger.IsBusinessClass === price.IsBusinessClass,
    );

    const hasCampaign = prices.some((price) => price.IsCampaign);

    set(
      produce((state) => {
        state.tickets.products[directions][0].Legs[activeBus].SeatInfo[
          activePassenger
        ] = {
          ...passanger,
          HasCampaign: hasCampaign,
          IsCampaign: hasCampaign,
        };
      }),
    );
  },
  [setMultiFloorOccupiedBusNotified]: () => {
    set(
      produce((state) => {
        state.tickets.multiFloorOccupiedBusNotified = true;
      }),
    );
  },
  [setSeatShiftNotified]: () => {
    set(
      produce((state) => {
        state.tickets.seatShiftNotified = true;
      }),
    );
  },
  [updateLegsViewed]: (isOutbound, number) => {
    set(
      produce((state) => {
        if (
          !state.tickets.legsViewed[
            isOutbound ? "outbound" : "inbound"
          ].includes(number)
        ) {
          state.tickets.legsViewed[isOutbound ? "outbound" : "inbound"].push(
            number,
          );
        }

        const isAllOutboundLegsViewed =
          state.tickets.products.OutboundJourneys[0].Legs.length ===
          state.tickets.legsViewed.outbound.length;

        let isAllInboundLegsViewed = true;

        if (state.tickets.legsViewed.inbound) {
          isAllInboundLegsViewed =
            state.tickets.products.InboundJourneys[0].Legs.length ===
            state.tickets.legsViewed.inbound.length;
        }

        if (isAllOutboundLegsViewed && isAllInboundLegsViewed) {
          state.tickets.seatShiftNotified = true;
          state.tickets.hasSeatShift = false;
        }
      }),
    );
  },
  [setNewFareClasses]: (availableBonusSchemes) => {
    set(
      produce((state) => {
        try {
          const outboundLegs = get().tickets.products.OutboundJourneys[0].Legs;
          const inboundLegs = get().tickets.products.InboundJourneys?.[0]?.Legs;
          const products = get().tickets.products.OutboundJourneys[0].Products;

          products.forEach((_, idx) => {
            outboundLegs.forEach((leg) => {
              const bonuses =
                availableBonusSchemes[idx].OutboundLegs[leg.OrderNumber - 1]
                  .Bonuses;
              state.tickets.products.OutboundJourneys[0].Legs[
                leg.OrderNumber - 1
              ].SeatInfo[idx].Bonuses = bonuses;
            });

            if (inboundLegs?.length) {
              inboundLegs.forEach((leg) => {
                const bonuses =
                  availableBonusSchemes[idx].InboundLegs[leg.OrderNumber - 1]
                    .Bonuses;
                state.tickets.products.InboundJourneys[0].Legs[
                  leg.OrderNumber - 1
                ].SeatInfo[idx].Bonuses = bonuses;
              });
            }
          });
        } catch (e) {
          console.log("[setNewFareClasses]", e);
        }
      }),
    );
  },
  [setBusFloor]: (payload) => {
    console.log("!!!!!! setBusFloor payload", payload);
    set(
      produce((state) => {
        state.tickets.activeBusFloor = payload;
      }),
    );
  },
  [updateFareClasses]: (bonus) => {
    set(
      produce((state) => {
        try {
          const activePassenger = state.tickets.activePassenger;
          const outboundLegs = get().tickets.products.OutboundJourneys[0].Legs;
          const inboundLegs = get().tickets.products.InboundJourneys?.[0]?.Legs;

          outboundLegs.forEach((leg, key) => {
            const bonuses = leg.SeatInfo[activePassenger - 1]?.Bonuses;
            const isExistBonus = bonuses.find(
              (b) => b.FareClass === bonus.FareClass,
            );

            if (isExistBonus) {
              state.tickets.products.OutboundJourneys[0].Legs[
                leg.OrderNumber - 1
              ].SeatInfo[activePassenger - 1].fareClass = isExistBonus;
            }
          });

          if (inboundLegs?.length) {
            inboundLegs.forEach((leg) => {
              const bonuses = leg.SeatInfo[activePassenger - 1].Bonuses;
              const isExistBonus = bonuses.find(
                (b) => b.FareClass === bonus.FareClass,
              );

              if (isExistBonus) {
                state.tickets.products.InboundJourneys[0].Legs[
                  leg.OrderNumber - 1
                ].SeatInfo[activePassenger - 1].fareClass = isExistBonus;
              }
            });
          }
        } catch (e) {
          console.log("[updateFareClasses]", e);
        }
      }),
    );
  },
  [initUpdateFareClasses]: () => {
    set(
      produce((state) => {
        try {
          const products = get().tickets.products;
          const outboundLegs = products.OutboundJourneys[0].Legs;
          const inboundLegs = products.InboundJourneys?.[0]?.Legs;
          const outboundProducts = products.OutboundJourneys[0].Products;
          const inboundProducts = products.InboundJourneys?.[0]?.Products;

          // processing outbound passengers
          outboundProducts.forEach((product, passengerIndex) => {
            const requestedFareClass = product.RequestedFareClass;

            if (requestedFareClass) {
              outboundLegs.forEach((leg) => {
                const seatInfo = leg.SeatInfo[passengerIndex];
                if (seatInfo && seatInfo.Bonuses) {
                  const matchingBonus = seatInfo.Bonuses.find(
                    (bonus) => bonus.FareClass === requestedFareClass,
                  );

                  if (matchingBonus) {
                    state.tickets.products.OutboundJourneys[0].Legs[
                      leg.OrderNumber - 1
                    ].SeatInfo[passengerIndex].fareClass = matchingBonus;
                  }
                }
              });
            }
          });

          // processing inbound passengers (if exist)
          if (inboundLegs?.length && inboundProducts?.length) {
            inboundProducts.forEach((product, passengerIndex) => {
              const requestedFareClass = product.RequestedFareClass;

              if (requestedFareClass) {
                inboundLegs.forEach((leg) => {
                  const seatInfo = leg.SeatInfo[passengerIndex];
                  if (seatInfo && seatInfo.Bonuses) {
                    const matchingBonus = seatInfo.Bonuses.find(
                      (bonus) => bonus.FareClass === requestedFareClass,
                    );

                    if (matchingBonus) {
                      state.tickets.products.InboundJourneys[0].Legs[
                        leg.OrderNumber - 1
                      ].SeatInfo[passengerIndex].fareClass = matchingBonus;
                    }
                  }
                });
              }
            });
          }
        } catch (e) {
          console.log("[initUpdateFareClasses]", e);
        }
      }),
    );
  },
  setExtraSeatLoading: (payload) => {
    set((state) => ({
      ...state,
      tickets: {
        ...state.tickets,
        extraSeatLoading: payload,
      },
    }));
  },
  setExtraSeat: (seat, extraProduct, extraSeatInfo, priceClass) => {
    set(
      produce((state) => {
        try {
          if (!state.tickets.products?.OutboundJourneys?.[0]) {
            console.error("OutboundJourneys not found in state");
            return;
          }

          if (extraProduct) {
            state.tickets.products.OutboundJourneys[0].Products.push(
              extraProduct,
            );
          }

          if (!state.tickets.products.OutboundJourneys[0].Legs?.[0]?.SeatInfo) {
            console.error("SeatInfo not found in state");
            return;
          }

          const activePassengerSeatInfo =
            state.tickets.products.OutboundJourneys[0].Legs[0].SeatInfo[
              state.tickets.activePassenger - 1
            ];

          if (!activePassengerSeatInfo) {
            console.error("Active passenger seat info not found");
            return;
          }

          const fareClass = activePassengerSeatInfo.Bonuses.find(
            (seat) => seat.FareClass === priceClass,
          );

          state.tickets.products.OutboundJourneys[0].Legs[0].SeatInfo.push({
            ...activePassengerSeatInfo,
            // ...extraSeatInfo,
            fareClass,
            TicketNumber: extraSeatInfo.TicketNumber,
            SeatNumber: extraSeatInfo.SeatNumber,
            ProductId: extraSeatInfo.ProductId,
            ownerProductId: activePassengerSeatInfo.ProductId,
            IsExtraSeat: true,
          });

          state.tickets.extraSeatsCount =
            (state.tickets.extraSeatsCount || 0) + 1;

          state.tickets.extraSeatsIds = [
            ...(state.tickets.extraSeatsIds || []),
            extraProduct.ProductId,
          ];
        } catch (error) {
          console.error("Error in setExtraSeat:", error);
        }
      }),
    );
  },
  removeExtraSeat: (productId) => {
    set(
      produce((state) => {
        state.tickets.products.OutboundJourneys[0].Products =
          state.tickets.products.OutboundJourneys[0].Products.filter(
            (product) => product.ProductId !== productId,
          );

        state.tickets.extraSeatsIds = state.tickets.extraSeatsIds.filter(
          (id) => id !== productId,
        );

        state.tickets.products.OutboundJourneys[0].Legs[0].SeatInfo =
          state.tickets.products.OutboundJourneys[0].Legs[0].SeatInfo.filter(
            (seat) => seat.ProductId !== productId,
          );

        state.tickets.extraSeatsCount =
          (state.tickets.extraSeatsCount || 0) - 1;
      }),
    );
  },
  changeExtraSeatNumber: (payload) => {
    set(
      produce((state) => {
        const { directions, activeBus, activePassenger, passanger } = payload;

        const prices = passanger.Prices.filter(
          (price) => passanger.IsBusinessClass === price.IsBusinessClass,
        );

        const extraSeatIndex = state.tickets.products[directions][0].Legs[
          activeBus
        ].SeatInfo.findIndex((seat) => seat.ProductId === passanger.ProductId);

        const hasCampaign = prices.some((price) => price.IsCampaign);

        state.tickets.products[directions][0].Legs[activeBus].SeatInfo[
          extraSeatIndex
        ] = {
          ...passanger,
          HasCampaign: hasCampaign,
          IsCampaign: hasCampaign,
        };

        try {
          const hasMultiFloorOccupiedBus = checkHasMultiFloorOccupiedBus(
            state.tickets.products,
          );

          state.tickets.hasMultiFloorOccupiedBus = hasMultiFloorOccupiedBus;
        } catch (e) {
          console.log("e", e);
        }
      }),
    );
  },
});
